import React, { useEffect, useRef, useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";

const DropdownCustom = ({
  data,
  name,
  width,
  type,
  setData,
  defaultData,
  value,
  selectedValue,
  compact,
  updatePayyroStatus,
  updateDocumentStatus,
}) => {
  const menuRef = useRef();
  const menuListRef = useRef();
  const [showMe, setShowMe] = useState(false);
  const [searchText, setSearchText] = useState(defaultData);
  const [newData, setNewData] = useState(data);

  const handleOutsideClick = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      menuListRef.current &&
      !menuListRef.current.contains(event.target)
    ) {
      setShowMe(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // Keep the rendered list in sync when the `data` prop changes (e.g. MCC/MNC
  // options loading after a country is picked). Previously the parent forced a
  // remount to achieve this; syncing here is the correct, remount-free fix.
  useEffect(() => {
    setNewData(data);
  }, [data]);

  // Controlled display: when the parent-provided selected value (or the options) change, show the
  // matching option's label — so e.g. "Clear Filters" setting the value to "" actually clears the
  // box. Pages that don't pass `selectedValue` stay uncontrolled (unchanged behaviour).
  useEffect(() => {
    if (selectedValue === undefined) return;
    const match = (data || []).find((o) => String(o.value) === String(selectedValue));
    setSearchText(match ? match.label : "");
  }, [selectedValue, data]);

  const toggleCharter = () => {
    setShowMe(!showMe);
  };

  const searchData = async (text) => {
    setSearchText(text);
    setShowMe(true);
    if (text) {
      try {
        const newData = data.filter((item) => {
          console.log("item.value", item.value);
          if (item.label.toLowerCase().includes(text.toLowerCase())) {
            return item.label.toLowerCase().includes(text.toLowerCase());
          }
        });
        setNewData(newData);
      } catch (error) {}
    } else {
      setNewData(data);
    }
  };

  const handleClick = (item) => {
    setSearchText(item.label);
    setShowMe(false);
    setData(item.value);

    if (type === "document") {
      updateDocumentStatus(item.value);
    } else if (type === "payyro") {
      updatePayyroStatus(item.value);
    }
  };

  // useEffect(() => {
  //   setSearchText(setData || "");
  // }, [setData]);

  return (
    <div className="relative max-sm:w-full">
      <div
        className={`relative flex items-center w-full`}
        onClick={toggleCharter}
        style={{ width: width || (compact ? "100%" : undefined) }}
        ref={menuRef}
      >
        <input
          type="text"
          onChange={(e) => searchData(e.target.value)}
          className={
            compact
              ? `w-full h-8 cursor-pointer border border-gray-300 rounded-md pl-2 pr-6 text-xs max-sm:w-full`
              : `form-input cursor-pointer font-bold max-sm:w-full`
          }
          placeholder={name}
          value={searchText === "All" ? "" : searchText}
        />
        <div
          className={`absolute ${
            compact ? "h-8 w-6" : "h-9 w-9"
          } right-0.5 cursor-pointer border border-transparent rounded-md bg-transparent flex items-center justify-center`}
        >
          <IoMdArrowDropdown
            className={`duration-300 ${
              showMe ? "rotate-180 text-primary" : "rotate-0"
            } ${
              compact ? "h-4 w-4" : "h-5 w-5 text-xl"
            } cursor-pointer text-[#80929f]`}
          />
        </div>
      </div>

      {(searchText || showMe) && (
        <>
          <div
            ref={menuListRef}
            className={`absolute ${
              compact ? "top-[36px]" : "top-[50px]"
            } max-h-[350px] left-0 rounded-lg shadow-full z-50 h-fit w-full overflow-auto bg-white ${
              showMe ? "block" : "hidden"
            }`}
            style={{
              width: width,
            }}
          >
            {newData.map((item, index) => {
              return (
                <div className={`hover:bg-primary/5`} key={index}>
                  <div
                    className={`flex cursor-pointer px-1 py-3 items-center mx-2`}
                    onClick={() => handleClick(item)}
                  >
                    <div className="text-[14px]">{item.label}</div>
                  </div>
                  {newData.length - 1 !== index && (
                    <div className="border-b border-[#ebebeb] mx-2"></div>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default DropdownCustom;
